import logo from "./cod-logo.svg";
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="logo-wrapper">
        <img src={logo} alt="Company Logo" className="loading-logo" />
      </div>
      {/* <div className="loading-text">Loading<span className="dots">...</span></div> */}
    </div>
  );
};

export default Loading;
